import {Button, Checkbox, DatePicker, Form, Input, message, Spin, Upload} from "antd";
import {db, auth, storage} from "./base";
import {InboxOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {addDoc, collection, getDocs, query} from "firebase/firestore";
import {
    ref,
    uploadBytes,
    listAll,
    getDownloadURL,
    getStorage,
} from "firebase/storage";
import NavBar from "./components/NavBar";
import dayjs from "dayjs";

const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
};

const NotificationPage = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(true);
    const [imageList, setImageList] = useState([]);
    const [selectedImg, setSelectedImg] = useState("");
    const [fileList, setFileList] = useState([]);

    const {Dragger} = Upload;

    function getImages() {
        const q = query(collection(db, "notifiche"));
        getDocs(q).then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
            });
        });

        listAll(ref(storage, "notifiche/"))
        .then((res) => {
            let promises = res.items.map((imageRef) => getDownloadURL(imageRef));
            Promise.all(promises).then((urls) => {
                setImageList(urls);
                setLoading(false);
            });
        })
        .catch((err) => {
            console.log('qui', err);
        });
    }

    useEffect(() => {
        getImages();
    }, []);

    const [form] = Form.useForm();

    const onFinish = async (values) => {
        setLoading(true);

        let nextData = {
            titolo: values.title,
            testo: values.text,
            creazione: new Date(),
        }

        if(values.scheduleTime) {
            nextData.programmato_per = dayjs(values.scheduleTime).toDate();
        }

        try {
            if (fileList[0]) {
                const storage = await getStorage();
                const storageRef = ref(
                    storage,
                    "notifiche/" + new Date() + fileList[0].name
                );
                await uploadBytes(storageRef, fileList[0].originFileObj);
                const url = await getDownloadURL(storageRef);
                await addDoc(collection(db, "notifiche"), {...nextData, immagine: url});
            } else {
                await addDoc(collection(db, "notifiche"), {...nextData, immagine: selectedImg});
            }
            alert('Notifica creata con successo');
        } catch(e) {
            console.log(e)
            alert("Qualcosa è andato storto");
            setLoading(false);
        } finally {
            form.resetFields();
            setFileList([]);
            setSelectedImg();
            getImages();
            setLoading(false);
        }
    };

    if (loading)
        return (
            <div className="absolute-center">
                <Spin/>
            </div>
        );

    const beforeUpload = (file) => {
        if (!["image/jpeg", "image/png"].includes(file.type)) {
            message.error(`${file.name} is not a valid image type`, 2);
            return null;
        }
        return false;
    };

    const handleChange = ({fileList}) =>
        setFileList(fileList.filter((file) => file.status !== "error"));

    const onRemove = () => {
        setFileList([]);
    };

    return (
        <>
            <NavBar/>
            <main>
                <h1>Crea una notifica</h1>
                <Form
                    form={form}
                    layout="vertical"
                    name="basic"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    {contextHolder}
                    <Form.Item
                        label="Titolo"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: "Inserisci il titolo",
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Testo"
                        name="text"
                        rules={[
                            {
                                required: true,
                                message: "Inserisci del testo",
                            },
                        ]}
                    >
                        <Input.TextArea autoSize={{minRows: 2, maxRows: 6}}/>
                    </Form.Item>
                    {!fileList[0] && (
                        <>
                            <p>Seleziona un'immagine</p>
                            <div className="select-img-grid">
                                {imageList.map((item) => {
                                    return (
                                        <img
                                            key={item}
                                            className={
                                                selectedImg === item
                                                    ? "grid-child-active"
                                                    : "grid-child"
                                            }
                                            onClick={() => {
                                                setSelectedImg(item);
                                            }}
                                            src={item}
                                        />
                                    );
                                })}
                            </div>
                        </>
                    )}

                    <Dragger
                        accept=".png,.jpeg,.jpg"
                        listType="picture-card"
                        fileList={fileList}
                        beforeUpload={beforeUpload}
                        onChange={handleChange}
                        onRemove={onRemove}
                        multiple={false}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined/>
                        </p>
                        <p className="ant-upload-text">Oppure carica una nuova immagine</p>
                    </Dragger>
                    <Form.Item name={'scheduleTime'} label={'Invia il'} style={{marginTop: 20}}>
                        <DatePicker minuteStep={30} style={{width: '100%'}} showTime
                                    format={'DD/MM/YYYY hh:mm'}/>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            style={{width: "100%", marginTop: 30}}
                        >
                            Crea notifica
                        </Button>
                    </Form.Item>
                </Form>
            </main>
        </>
    );
};
export default NotificationPage;
